const MOSCOW_DATE_FORMAT = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Europe/Moscow',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})

export function moscowToday(): string {
  return MOSCOW_DATE_FORMAT.format(new Date())
}

export function addDays(iso: string, days: number): string {
  const date = new Date(`${iso}T00:00:00.000Z`)
  date.setUTCDate(date.getUTCDate() + days)
  return date.toISOString().slice(0, 10)
}

const DAY_FORMAT = new Intl.DateTimeFormat('ru-RU', { timeZone: 'UTC', day: 'numeric' })
const WEEKDAY_FORMAT = new Intl.DateTimeFormat('ru-RU', { timeZone: 'UTC', weekday: 'short' })
const LONG_FORMAT = new Intl.DateTimeFormat('ru-RU', { timeZone: 'UTC', day: 'numeric', month: 'long', weekday: 'long' })

function utc(iso: string): Date {
  return new Date(`${iso}T00:00:00.000Z`)
}

export function dayNumber(iso: string): string {
  return DAY_FORMAT.format(utc(iso))
}

export function weekdayShort(iso: string): string {
  return WEEKDAY_FORMAT.format(utc(iso))
}

export function longDate(iso: string): string {
  return LONG_FORMAT.format(utc(iso))
}

const MONTH_FORMAT = new Intl.DateTimeFormat('ru-RU', { timeZone: 'UTC', month: 'long' })
const DAY_MONTH_FORMAT = new Intl.DateTimeFormat('ru-RU', { timeZone: 'UTC', day: 'numeric', month: 'long' })

export function mondayOf(iso: string): string {
  return addDays(iso, -((utc(iso).getUTCDay() + 6) % 7))
}

export function monthTitle(iso: string): string {
  const name = MONTH_FORMAT.format(utc(iso))
  return `${name.charAt(0).toUpperCase()}${name.slice(1)} ${iso.slice(0, 4)}`
}

export function rangeLabel(from: string, to: string): string {
  if (from.slice(0, 7) === to.slice(0, 7)) return `${dayNumber(from)}–${DAY_MONTH_FORMAT.format(utc(to))}`
  return `${DAY_MONTH_FORMAT.format(utc(from))} – ${DAY_MONTH_FORMAT.format(utc(to))}`
}

export function dayMonth(iso: string): string {
  return DAY_MONTH_FORMAT.format(utc(iso))
}
